import { useMutation } from "@apollo/client";
import { DELETE_COMPANY_DOCUMENT_FOLDER } from "../api/delete-company-document-folder";
import { useNotification } from "@/shared/feedback/notification";
import { useTranslations } from "use-intl";
import { GET_COMPANY_DOCUMENT_TREE } from "@/modules/documents/widgets/company-document-tree/api/get-company-document-tree";
import { GET_COMPANY_DOCUMENT_FOLDER_TREE } from "@/modules/documents/entities/company-document-folder-select/api/get-company-document-folder-tree";

export function useDeleteCompanyDocumentFolder() {
  const t = useTranslations("CompanyDocumentFolder");
  const notify = useNotification();
  const [deleteFolder, { loading }] = useMutation(
    DELETE_COMPANY_DOCUMENT_FOLDER,
    {
      refetchQueries: [
        GET_COMPANY_DOCUMENT_TREE,
        GET_COMPANY_DOCUMENT_FOLDER_TREE,
      ],
    },
  );

  const remove = async (id: string) => {
    const response = await deleteFolder({ variables: { id } });

    if (response.data?.deleteCompanyDocumentFolder) {
      notify?.success({ message: t("Folder deleted successfully") });
    }
  };

  return { remove, loading };
}
